export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11910.62416721.jpg";